export const SOCKET_USER = '200';
export const SOCKET_USER_DOCTOR = 'doctor';

export const SOCKET_EVENT = {
  RECONNECT: 'reconnect',
  DISCONNECT: 'disconnect',
  JOIN: 'join',
  JOIN_ACCOUNT: 'joinaccount',
  REQUEST_START: 'requeststart',
  STATUS: 'status',
  TOKEN_PING: 'tokenping',
  TOKEN_PONG: 'tokenpong',
  ROOM_MESSAGE: 'room message',
  SHARED_FILE: 'sharedfile',
  ORDER_MESSAGE: 'order message',
  ORDER_SEEN: 'orderseen',
  NEW_UNREAD: 'newunread',
  ERROR: 'error',
  OD_BOOKING_ACCEPT: 'odbooking-accept',
  OD_BOOKING_REJECT: 'odbooking-reject',
  OD_BOOKING_PAYMENTEXPIRE: 'odbooking-paymentexpire',
  OD_BOOKING_FORAPPROVAL: 'odbooking-forapproval',
};
